import React from "react";
import Social from "../home/Social";
import "./Home.css";
import Data from "../home/Data"
import ScrollDown from "../home/ScrollDown";

const Home = () => {
    return(
        <section className="home section" id="home">
            <div className="home__container  container grid">
                <div className="home__content grid">
                    <Social/>
                    <div className="home__img"></div>
                    <Data/>
                </div>
                <ScrollDown/>
            </div>
        </section>
    );
}

export default Home;